import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream py-12 sm:py-16" data-id="element-59" data-mp="1bl243ai5rafj">
      <div className="mx-auto max-w-3xl px-5" data-id="element-60" data-mp="1bmln38v77zl0">
        <h2 className="text-center font-display text-2xl font-black text-ink sm:text-4xl" data-id="element-61" data-mp="1gitwe5mpsyk9">
          Preguntas frecuentes
        </h2>

        <div className="mt-7 space-y-2.5" data-id="element-62" data-mp="249zmreqa798t">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-rose/10 bg-white shadow-sm" data-id="element-63" data-mp="1ujmroskubxof" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-3.5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-rose/40 sm:px-5" data-id="element-64" data-mp="1zgn0hb92rej8">
                  <span className="font-display text-[0.95rem] font-bold text-ink sm:text-base" data-id="element-65" data-mp="14sxsphb5ggnq">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-rose transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden data-id="element-66" data-mp="1em571rnvb6zy" />
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm leading-relaxed text-ink/70 sm:px-5 sm:pb-5" data-id="element-67" data-mp="1jk6rafx15cd0">
                    {faq.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}